<template>
    <div>
        <div class='d-flex justify-content-between align-items-center neue mbp-20'>
            <Icon v-if="isMobile" :name="'arrow-left'" class="pointer" @click="this.close" />
            <h4 class="mb-0 text-black neue fw-medium ml8" :class="{ 'flex-grow-1 text-center fsp20': this.isMobile }">{{ this.$store.state.modal.content.title }}</h4>
            <Icon v-if="!this.isMobile" @click='this.close' :name="'close'" class="pointer"  />
        </div>
        <div class="bg-white rounded" :class="{ 'pp-24': !this.isMobile }">
        <!-- !! -->
            <div>
                <div class="d-flex flex-row justify-content-start align-items-center">
                    <p class="mb-0 fsp20 text-black lh28 fw-medium">{{ $t('components.service.modal.PayHref.basic_parameters') }}</p>
                    <Tooltip
                        class="pointer ml8 primary-grey" 
                        style="border: 1px;"
                        :content="'hint'"  
                        :custom="'item-i info-asset c24'"
                    />
                </div>
                <div class="d-flex flex-column">
                    <div class="d-flex flex-column flex-md-row align-items-center justify-content-between mt16">
                        <div class="flex-grow-1"
                        :class="{ 'col-12': this.isMobile }">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 col-12 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.account_wallet') }}<span class="red"> *</span></label>
                        </div>
                        <div class="col-12"
                        :class="{ 'w384': !this.isMobile }">
                            <SelectSimple
                                id='on_keyt_shop' 
                                class="fsp14 lhp20"
                                :keyt="true"
                                :dataValue='this.data.on_keyt_shop' 
                                :isSearch="true" 
                                :defaultValue="$t('components.service.modal.PayHref.select_account_wallet')"
                                :keywords.sync='this.keywords' 
                                @updateParentState="this.updateState"  
                            />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row align-items-center mt16">
                        <div class="flex-grow-1" :class="{ 'col-12': this.isMobile }">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 col-12 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.3') }}<span class="red"> *</span></label>
                        </div>
                        <div class="col-12" :class="{ 'w384': !this.isMobile }">
                            <InputSimple type='text' :dataValue='this.data.on_sum'
                             id='on_sum' 
                             class="fsp14 lhp20"
                             :placeholder="$t('components.service.modal.PayHref.enter_amount')"
                             @updateParentState="this.updateState" 
                             :regCheck='{f: (num) => {
                                return this.$lib.checkPrecision(num, this.data.prec)
                             }}'/>
                        </div>
                    </div>
                    <div class="d-flex flex-md-row align-items-center mt16" :class="{ 'justify-content-between': this.isMobile }">
                        <div class="flex-grow-1">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.12') }}</label>
                        </div>
                        <div :class="{ 'w384 d-flex justify-content-end': !this.isMobile }">
                            <SwitchSimple :dataValue='this.data.on_identified' 
                            id='on_identified' 
                            @updateParentState="this.updateState"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb16 mt16 border-b"></div>

            <div>
                <div class="d-flex flex-row justify-content-between align-items-center pointer gap-3"
                    id="m-p-h-acc1"
                    v-on:click="() => {this.accordion.advanced = !this.accordion.advanced; this.accordion.urls = false}">
                    <div class="d-flex flex-row justify-content-start align-items-center">
                        <p class="mb-0 fsp20 lh28 fw-medium text-black">{{ $t('components.service.modal.PayHref.advanced_settings') }}</p>
                        <Tooltip
                            class="pointer ml8" 
                            style="border: 1px;"
                            :content="'hint'" 
                            :htmlContent="true"
                        >
                            <Icon name="info" class="c18" />
                        </Tooltip>
                    </div>
                    <Icon :name="this.accordion.advanced ? 'chevron-up' : 'chevron-down'" class="pointer"/>
                </div>
                <div class="d-flex flex-column" v-if="this.accordion.advanced">
                    <div class="d-flex flex-column flex-md-row align-items-center mt16">
                        <div class="flex-grow-1" :class="{ 'col-12': this.isMobile }">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 col-12 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.17') }}</label>
                        </div>
                        <div class="col-12" :class="{ 'w384': !this.isMobile }">
                            <p class="mb-0 fsp16 lhp24 hrf string_ellipsis" :class="{ 'text-end': !this.isMobile, 'text-start': this.isMobile }" id='hh' v-on:click="this.$lib.routNewTab('/docs/merchant', this.$router)">{{ this.docUrl }}</p>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row align-items-center mt16">
                        <div class="flex-grow-1" :class="{ 'col-12': this.isMobile }">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 col-12 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.payment_method') }}</label>
                        </div>
                        <div class="col-12" :class="{ 'w384': !this.isMobile }">
                            <SelectSimple  id='on_payform' 
                            :dataValue='this.data.on_payform' 
                            :hotUpdate="true" 
                            class="fsp14 lhp20"
                            :defaultValue="$t('components.service.modal.PayHref.select_payment_method')"
                            :keywords.sync='this.pay_sys_keyword' 
                            @updateParentState="this.updateState"/>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row align-items-center mt16">
                        <div class="flex-grow-1" :class="{ 'col-12': this.isMobile }">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 col-12 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.2') }}<span class="red"> *</span></label>
                        </div>
                        <div class="col-12" :class="{ 'w384': !this.isMobile }">
                            <InputSimple type='text' :dataValue='this.data.on_ext_transact'
                             id='on_ext_transact' 
                             class="fsp14 lhp20"
                             @updateParentState="this.updateState"/>
                        </div>
                    </div>
                    <div class="d-flex flex-column align-items-start justify-content-center mt16">
                        <div class="flex-grow-1" :class="{ 'col-12': this.isMobile }">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 col-12 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.4') }}</label>
                        </div>
                        <div class="col-12">
                            <InputSimple type='textarea' 
                            :dataValue='this.data.on_comment' 
                            id='on_comment' 
                            class="fsp14 lhp20"         
                            @updateParentState="this.updateState"/>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row align-items-center mt16">
                        <div class="flex-grow-1" :class="{ 'col-12': this.isMobile }">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 col-12 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.19') }}</label>
                        </div>
                        <div class="col-12" :class="{ 'w384': !this.isMobile }">
                            <InputSimple type='text' :dataValue='this.data.on_timeout' 
                            id='on_timeout' 
                            class="fsp14 lhp20"     
                            @updateParentState="this.updateState" >
                                <span class="primary-grey mr8 fsp14 lhp20">Min</span>
                            </InputSimple>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row align-items-center mt16">
                        <div class="flex-grow-1" :class="{ 'col-12': this.isMobile }">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 col-12 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.5') }}</label>
                        </div>
                        <div class="col-12" :class="{ 'w384': !this.isMobile }">
                            <InputSimple type='text' :dataValue='this.data.on_free_param' 
                            id='on_free_param' 
                            class="fsp14 lhp20" 
                            @updateParentState="this.updateState"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb16 mt16 border-b"></div>

            <div>
                <div class="d-flex flex-row justify-content-between align-items-center mb16 gap-3 pointer" 
                    id="m-p-h-acc2"
                    v-on:click="() => {this.accordion.urls = !this.accordion.urls; this.accordion.advanced = false}">
                    <div class="d-flex flex-row justify-content-start align-items-center">
                        <div class="mb-0 fsp20 w-100 lh28 fw-medium text-black">
                            {{ $t('components.service.modal.PayHref.notification_return_url') }}
                        </div>
                        <Tooltip
                            class="pointer ml8" 
                            style="border: 1px;"
                            :content="'hint'" 
                            :htmlContent="true"
                        >
                            <Icon name="info" class="c18" />
                        </Tooltip>
                    </div>
                    <Icon :name="this.accordion.urls ? 'chevron-up' : 'chevron-down'" class="pointer"/>
                </div>
                <div class="d-flex flex-column" v-if="this.accordion.urls">
                    <div class="d-flex flex-column flex-md-row align-items-center">
                        <div class="flex-grow-1" :class="{ 'col-12': this.isMobile }">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 col-12 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.7') }}</label>
                        </div>
                        <div class="col-12" :class="{ 'w384': !this.isMobile }">
                            <InputSimple type='text' :dataValue='this.data.on_url_decline' 
                            id='on_url_decline' 
                            class="fsp14 lhp20"
                            @updateParentState="this.updateState" />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row align-items-center mt16">
                        <div class="flex-grow-1" :class="{ 'col-12': this.isMobile }">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 col-12 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.6') }}</label>
                        </div>
                        <div class="col-12" :class="{ 'w384': !this.isMobile }">
                            <InputSimple type='text' :dataValue='this.data.on_url_success' 
                            id='on_url_success' 
                            class="fsp14 lhp20"
                            @updateParentState="this.updateState"/>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row align-items-center my24">
                        <div class="flex-grow-1" :class="{ 'col-12': this.isMobile }">
                            <label for="on_keyt_shop" class="mt-0 pl-0 pt-0 col-12 pb-0 text-black pr-1 lh20 fsp14 neue-roman" :class="{ 'mb8': this.isMobile }">{{ $t('components.service.modal.PayHref.8') }}</label>
                        </div>
                        <div class="col-12" :class="{ 'w384': !this.isMobile }">
                            <InputSimple type='text' :dataValue='this.data.on_url_callback' 
                            id='on_url_callback' 
                            class="fsp14 lhp20"
                            @updateParentState="this.updateState"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb24 mt16 border-b"></div>

            <div class="d-flex flex-row gap-3 align-items-center">
                <Button class="flex-grow-1 btn-h48 fsp14 lhp20" :name="$t('components.service.modal.WidgetData.2')" type='btn-outline-grey' 
                id="m-p-h-btn1"
                v-on:click='() => {
                    this.close();
                }'/>
                <Button class="flex-grow-1 btn-h48 fsp14 lhp20"
                id="m-p-h-btn2"
                :name="$t('components.service.modal.WidgetData.4')" type='btn-warning' :disabled="!this.ready" v-on:click="() => {this.createCode()}"/>
            </div>
            <!-- v-if="this.payLink" -->
            <div v-if="this.payLink">
                <div class="mb16 mt24 border-b"></div>

                <CustomSelectButton
                    class="w-100 h40 mb16"
                    id="1"
                    v-model:modelValue="this.output_type"
                    :options="[
                        { label: $t('components.service.modal.PayHref.20'), value: 'link' }, 
                        { label: $t('components.service.modal.PayHref.21'), value: 'form' }, 
                        { label: $t('components.service.modal.PayHref.22'), value: 'widget' }
                    ]" 
                />
                <div v-if="this.output_type == 'link'">
                    <div class="d-flex flex-row align-items-center rounded8 p4 border-full h40">
                        <Icon name='link' class="c14 ml8 pointer"
                            v-on:click="this.redir(this.payLink)"
                        />
                        <p class="mb-0 flex-grow-1 fsp14 lhp20 ml8 string_ellipsis">
                            {{ this.payLink }}
                        </p>
                        <Button 
                            type='btn-warning'
                            class="btn-h32 fsp14 lhp16" 
                            id="m-p-h-btn3"
                            v-on:click="() => {this.copyLink(this.payLink)}"
                        >
                            <Icon name="copy" :active="false" :size="'c16'" />
                            <span class="ml4">
                                {{ $t('components.service.modal.PayHref.13') }}
                            </span>
                        </Button>
                    </div>
                </div>
                <div v-if="this.output_type == 'form'">
                    <div class="bg-light-grey rounded8 p16 pt0 d-flex flex-row align-items-start justify-content-start">
                        <highlightjs
                            language="html"
                            :code="this.payForm"
                        />
                        <Button 
                            type='btn-warning'
                            class="btn-h32 ml8 fsp14 lhp16 mt16" 
                            id="m-p-h-btn4"
                            v-on:click="() => {this.copyLink(this.payForm)}"
                        >
                            <Icon name="copy" :active="false" :size="'c16'" />
                            <span class="ml4">
                                {{ $t('components.service.modal.PayHref.13') }}
                            </span>
                        </Button>
                    </div>
                </div>
                <div v-if="this.output_type == 'widget'">
                    <div class="bg-light-grey rounded8 p16 pt0 d-flex flex-row align-items-start justify-content-start">
                        <highlightjs
                            language="html"
                            :code="this.payObject"
                        />
                        <Button 
                            type='btn-warning'
                            class="btn-h32 ml8 fsp14 lhp16 mt16" 
                            id="m-p-h-btn5"
                            v-on:click="() => {this.copyLink(this.payObject)}"
                        >
                            <Icon name="copy" :active="false" :size="'c16'" />
                            <span v-if="this.$store.state.resize.w > 768" class="ml4">
                                {{ $t('components.service.modal.PayHref.13') }}
                            </span>
                        </Button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template> 

<script>
// import 'highlight.js/styles/stackoverflow-light.css'
import 'highlight.js/styles/vs.css';
import Button from '@/components/service/Button'; 
import SelectSimple from '@/components/service/SelectSimple';
import Input from '@/components/service/Input';
import Icon from "@/components/icons/Icon.vue";
import Switch from '@/components/service/Switch';
import InputSimple from '@/components/service/InputSimple';
import SwitchSimple from '@/components/service/SwitchSimple';
import Tooltip from '@/components/service/Tooltip';
import 'highlight.js/lib/common';
import hljsVuePlugin from "@highlightjs/vue-plugin";
import CustomSelectButton from '@/components/service/CustomSelectButton';

export default {
    components: {
        Button,
        SelectSimple,
        Input,
        Switch,
        InputSimple,
        SwitchSimple,
        Tooltip,
        Icon,
        highlightjs: hljsVuePlugin.component,
        CustomSelectButton,
    },
    props: {
        close: [Function],
    }, 
    data () {
        return { 
            content: this.$store.state.modal.content,
            doc: this.$store.state.modal.url.DOC,
            keywords: [],
            pay_sys_keyword: [],
            data: {
                on_payform: '0',
                on_ext_transact: 'automatic!',
                on_sum: '',
                on_comment: '',
                on_keyt_shop: '',
                on_free_param: '',
                on_identified: '1',
                on_url_success: 'http://' + this.$store.state.domains.CABINET_DOMAIN + '/merchant/invoices',
                on_url_decline: 'http://' + this.$store.state.domains.CABINET_DOMAIN + '/merchant/invoices',
                on_url_callback: '',
                on_timeout: '60',
                prec: 2,
            },
            accordion: {
                advanced: false,
                urls: false,
            },
            payLink: '',
            payForm: '',
            payObject: '',
            showUrls: false,
            output_type: 'link',
            docUrl: window.location.protocol + '//' + window.location.host + '/docs/merchant',
        }
    },
    created() {
        this.init();
    },
    mounted() {
        // console.log('DEBUG', this.content)
    },
    computed: {
        t () {
            let k = this.$store.getters.get_keyts_keywords;
            if (k.length > 0) {
                this.getKeyts(k);
            }
            return k;
        },
        ready() {
            return this.data.on_keyt_shop && this.data.on_sum && this.data.on_sum > 0 && this.data.on_ext_transact;
        },
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    watch: {
        t: {
            handler: function(newData, oldData) {
                // console.log(newData)
                this.getKeyts(newData);
            },
            deep: true,
        },
    },
    methods: {
        getKeyts(k) {
            this.keywords = k;
        },
        init() {
            this.axios.post('GetParamsEshop', {data: {num_eshop: this.content.code}}).then(res => {
                if (res.data.body.result !== 0) {
                    return;
                }
                let shop = res.data.body.tables?.shops?.colvalues?.[0];

                if (shop.fail_url) {
                    this.data.on_url_decline = shop.fail_url;
                }
                if (shop.success_url) {
                    this.data.on_url_success = shop.success_url;
                }
                if (shop.callback_url) {
                    this.data.on_url_callback = shop.callback_url;
                }
            });
        },
        updateState(arg) { 
            if (arg.id == 'on_identified') {
                if (arg.value == true) {
                    arg.value = '1';
                } else {
                    arg.value = '0';
                }
            }
            this.data[arg.id] = arg.value;
            if (arg.id == 'on_keyt_shop') {
                this.data.prec = this.keywords.find(e => e.code == arg.value).precision;
                this.getListMerhcant(arg.value);
            }
        },
        getListMerhcant(arg) {
            this.pay_sys_keyword = [];
            this.data.on_payform = '0';
             this.axios.post('GetListMerchant', {data: {
                'keyt_pay': arg,
            }}).then(res => {
                res.data.body.forEach(e => {
                    this.pay_sys_keyword.push({code: e.form, value: e.name, how: e.how, type:e.type});
                })
            })
        },
        createCode() {
            let link_text = '?ext_transact=' + encodeURIComponent(this.data.on_ext_transact) + 
		    '&num_shop='     + encodeURIComponent(this.content.code    ) + 
		    '&keyt_shop='    + encodeURIComponent(this.data.on_keyt_shop  ) + 
		    '&identified='   + encodeURIComponent(this.data.on_identified ) + 
		    '&sum='          + encodeURIComponent(this.data.on_sum         ) + 
		    '&payform='      + encodeURIComponent(this.data.on_payform     ) +
		    '&comment='      + encodeURIComponent(this.data.on_comment     ) + 
		    '&free_param='   + encodeURIComponent(this.data.on_free_param  ) +
		    '&url_success='  + encodeURIComponent(this.data.on_url_success ) +
		    '&url_decline='  + encodeURIComponent(this.data.on_url_decline ) +
		    '&url_callback=' + encodeURIComponent(this.data.on_url_callback) + 
            '&timeout='      + encodeURIComponent(this.data.on_timeout);
	
	        // sign
            let sum = '';
	        if ( this.data.on_identified == '1' ) {
		        sum = this.data.on_sum;
            }
	        let signed_str = this.data.on_ext_transact + this.content.code + this.data.on_keyt_shop + this.data.on_identified + sum + this.data.on_payform + this.data.on_comment + this.data.on_free_param + this.data.on_url_success + this.data.on_url_decline + this.data.on_url_callback;
            let params = {
                signed_str: signed_str,
                secret_key: this.content.secret_key,
                key_dev: this.content.secret_key
            }
            this.axios.post('MerchantSign', {data: params}).then(res => {
                if (res.data.body.sign && res.data.body.url) {
                    this.payLink = res.data.body.url + link_text + '&sign=' + res.data.body.sign;
                    this.url = res.data.body.url;
                    this.payObject = 
`
let dataObject = {
    "frame_id": "${this.content.num}_id",
    "frame_name": "${this.content.num}_name",
    "pay_params": {
        "ext_transact": "${this.data.on_ext_transact}",
        "num_shop": "${this.content.num}",
        "keyt_shop": "${this.data.on_keyt_shop}",
        "identified": "${this.data.on_identified}",
        "sum": "${this.data.on_sum}",
        "payform": "${this.data.on_payform}",
        "comment": "${this.data.on_comment}",
        "free_param": "${this.data.on_free_param}",
        "url_success": "${this.data.on_url_success}",
        "url_decline": "${this.data.on_url_decline}",
        "url_callback": "${this.data.on_url_callback}",
        "proc_url": "${this.url}",
        "sign": "${res.data.body.sign}"
    },
    "onSuccess": function (result) {
        console.log(result) /// ${this.$t('components.service.modal.WidgetData.7')}
    },
    "onFail": function (result) {
        console.log(result) /// ${this.$t('components.service.modal.WidgetData.8')}
    }
}`;


                    this.payForm = `
<form method="post" action="${res.data.body.url}">
    <input type="hidden" name="ext_transact" value="${this.data.on_ext_transact}">
    <input type="hidden" name="num_shop" value="${this.content.num}">
    <input type="hidden" name="keyt_shop" value="${this.data.on_keyt_shop}">
    <input type="hidden" name="identified" value="${this.data.on_identified}">
    <input type="hidden" name="sum" value="${sum}">
    <input type="hidden" name="payform" value="${this.data.on_payform}">
    <input type="hidden" name="comment" value="${this.data.on_comment}">
    <input type="hidden" name="free_param" value="${this.data.on_free_param}">
    <input type="hidden" name="url_success" value="${this.data.on_url_success}">
    <input type="hidden" name="url_decline" value="${this.data.on_url_decline}">
    <input type="hidden" name="url_callback" value="${this.data.on_url_callback}">
    <input type="hidden" name="timeout" value="${this.data.on_timeout}">
    <input type="hidden" name="sign" value="${res.data.body.sign}">
    <input type="submit" value="Перейти к оплате">
</form>`
            }
        })

        },
        copyLink(arg) {
            let el = document.createElement("textarea");
            document.body.appendChild(el);
            el.value = arg;
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            this.$store.commit('NOTIFICATION', {
                type: 'success',
                text: this.$t('views.Home.41')
            })
        },
        redir(arg) {
            window.open(arg, '_blank').focus();
        },
    },
}
</script>

<style lang="scss">
code {
    color: #d63384 !important;
    background-color: transparent !important;
    padding: 0 !important;
    font-size: 14px !important;
    line-height: 16px !important;
}
.w384 {
    width: 384px !important;
}
</style>